<template>
  <div ref="root" class="components__dropdown-menu">
    <slot />
    <div class="dd-arrow" @click="handleArrowClick">
      <i v-if="open" class="frontend-icon fi-expand_less"></i>
      <i v-else class="frontend-icon fi-expand_more"></i>
    </div>
    <div ref="submenu" class="dd-submenu">
      <slot name="submenu" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~stylesheets/frontend/variables/colors";

.components__dropdown-menu {
  cursor: pointer;
  display: flex;
}

// style outside because tether moves it around
.dd-submenu {
  padding: 20px;
  background-color: $color-white;
}
</style>

<script lang="ts" setup>
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import Drop from "tether-drop";

  const props = defineProps({
    position: {
      type: String,
      default: "bottom center",
    },
    additionalClasses: {
      type: String,
      default: "",
    },
  });

  const dropInstance = ref<Drop | null>(null);
  const open = ref<boolean>(false);
  const root = ref<HTMLElement | null>(null);
  const submenu = ref<HTMLElement | null>(null);
  const handleArrowClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (root.value) {
      root.value.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    }
  };

  onMounted(() =>{
    ensureDropDestroy();
    dropInstance.value = new Drop({
      target: root.value ?? undefined,
      content: submenu.value ?? undefined,
      position: props.position,
      openOn: "click",
      remove: true,
      classes: props.additionalClasses,
    });
    dropInstance.value.on("open", () => {
      open.value = true;
    });
    dropInstance.value.on("close", () => {
      open.value = false;
    });
  })
    
  onBeforeUnmount(() =>{
    ensureDropDestroy();
  });

  const ensureDropDestroy = () => {
    if (dropInstance.value) {
      dropInstance.value.destroy();
      dropInstance.value = null;
    }
  };
</script>
